import React from "react"
import PropTypes from "prop-types"
import { Button } from "antd"
import { useTranslation } from "react-i18next"
import { Icon } from "ui/Icon"
import { colors } from "themes/variables"

/**
 * AI Enhancement Button - Reusable button for AI text enhancement features
 * @param {string} text - The text to check for minimum length
 * @param {number} minLength - Minimum text length required to enable button (default: 25)
 * @param {function} onClick - Click handler function
 * @param {boolean} disabled - Additional disabled condition (e.g., subscription status)
 */
export const AiEnhanceButton = ({ text = "", minLength = 25, onClick, disabled = false }) => {
  const { t } = useTranslation()

  // Check if text meets minimum length requirement
  const isTooShort = text.length < minLength

  // Button is disabled if text is too short OR additional disabled prop is true
  const isDisabled = disabled || isTooShort

  return (
    <Button
      color="primary"
      variant="solid"
      icon={<Icon name="aiEnhancement" color={isTooShort ? colors.textPrimary : colors.white} />}
      disabled={isDisabled}
      onClick={isDisabled ? undefined : onClick}
    >
      {t("pro.ai_enhancement.button_text")}
    </Button>
  )
}

AiEnhanceButton.propTypes = {
  text: PropTypes.string,
  minLength: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}
